import React from 'react';
import icon from '../../../../assets/dbs/db_egTest.png';

const EgTestIcon = () => (
    <div>
        <img style = {{height: 25, paddingBottom:5, paddingRight: 5}} src={icon} alt="egTest"/>
    </div>
);
export default EgTestIcon;